import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { SnackbarProvider } from './contexts/SnackbarContext';
import Login from './components/Login/Login';
import AdminLayout from './components/Layout/AdminLayout';
import Dashboard from './components/Dashboard/Dashboard';
import MosqueList from './components/Mosques/MosqueList';
import MosqueMapView from './components/Mosques/MosqueMapView';
import MosqueDetails from './components/Mosques/MosqueDetails';
import AddMosque from './components/Mosques/AddMosque';
import EditMosque from './components/Mosques/EditMosque';
import RestaurantList from './components/Restaurants/RestaurantList';
import RestaurantDetails from './components/Restaurants/RestaurantDetails';
import AddRestaurant from './components/Restaurants/AddRestaurant';
import EditRestaurant from './components/Restaurants/EditRestaurant';
import CampaignManager from './components/Campaigns/CampaignManager';
import Analytics from './components/Analytics/Analytics';
import LogsViewer from './components/Logs/LogsViewer';
import Reports from './components/Reports/Reports';
import ContributorList from './components/Contributors/ContributorList';
import ContributorDetails from './components/Contributors/ContributorDetails';
import { isAuthenticated, verifyToken } from './utils/auth';
import './styles/main.scss';

function App() {
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            if (isAuthenticated()) {
                const isValid = await verifyToken();
                setAuthenticated(isValid);
            }
            setLoading(false);
        };
        checkAuth();
    }, []);

    const ProtectedRoute = ({ children }) => {
        if (loading) {
            return <div className="loading">Loading...</div>;
        }
        return authenticated ? children : <Navigate to="/login" />;
    };

    return (
        <SnackbarProvider>
            <Router>
                <Routes>
                    <Route path="/login" element={<Login onLogin={() => setAuthenticated(true)} />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <AdminLayout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Dashboard />} />
                        <Route path="mosques" element={<MosqueList />} />
                        <Route path="mosques/map" element={<MosqueMapView />} />
                        <Route path="mosques/:mosqueID" element={<MosqueDetails />} />
                        <Route path="mosques/add" element={<AddMosque />} />
                        <Route path="mosques/:mosqueID/edit" element={<EditMosque />} />
                        <Route path="restaurants" element={<RestaurantList />} />
                        <Route path="restaurants/add" element={<AddRestaurant />} />
                        <Route path="restaurants/:restaurantID" element={<RestaurantDetails />} />
                        <Route path="restaurants/:restaurantID/edit" element={<EditRestaurant />} />
                        <Route path="campaigns" element={<CampaignManager />} />
                        <Route path="analytics" element={<Analytics />} />
                        <Route path="reports" element={<Reports />} />
                        <Route path="contributors" element={<ContributorList />} />
                        <Route path="contributors/:email" element={<ContributorDetails />} />
                        <Route path="logs" element={<LogsViewer />} />
                    </Route>
                </Routes>
            </Router>
        </SnackbarProvider>
    );
}

export default App;
